export const baseUrl = {
    sdk: location.protocol + '//sdk.nextjoy.com',
    api: location.protocol + '//h5.nextjoy.com',
    pay: location.protocol + '//pay.nextjoy.com'
}
export function getUrlParam(param) {
   return decodeURIComponent((new RegExp('[?|&]' + param + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
}


// WEBPACK FOOTER //
// ./src/summary/assets/js/baseUrl.js